import { render, staticRenderFns } from "./v-file-item.vue?vue&type=template&id=7e9309bb&"
import script from "./v-file-item.vue?vue&type=script&lang=js&"
export * from "./v-file-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports